module.exports = __webpack_public_path__ + "img/about.c7a1db69.png";